// extracted by mini-css-extract-plugin
module.exports = {"max-line-1":"common_max-line-1__Cphlh","max-line-2":"common_max-line-2__FLNFt","max-line-3":"common_max-line-3__MdXL5","max-line-4":"common_max-line-4__OX7dh","section_title":"common_section_title__reXmJ","section_desc":"common_section_desc__Vjrqq"};
module.exports.__checksum = "dbdde69fe76e"
